import { useFirebaseContext, CircularProgress, useConfigurationContext } from '@medely/ui-kit';
import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import { StringParam, useQueryParams } from 'use-query-params';
import { SignedDocumentWebView } from './SignedDocument';
import { ContractWebView } from './Contract';

export const WebViews = () => {
  const config = useConfigurationContext();
  const { googleUser } = useFirebaseContext();

  const [{ webViewToken }] = useQueryParams({ webViewToken: StringParam });

  const { signInWithToken } = useFirebaseContext();
  useEffect(() => {
    const signIn = async (token: string) => {
      try {
        await signInWithToken(token);
      } catch (e) {
        console.error(e);
      }
    };
    if (webViewToken) {
      signIn(webViewToken);
    }
  }, [webViewToken]);

  return !!googleUser ? (
    <Switch>
      <Route path={`${config.root}/wv/signed_document`} component={SignedDocumentWebView} />
      <Route path={`${config.root}/wv/contract`} component={ContractWebView} />
    </Switch>
  ) : (
    <CircularProgress />
  );
};
